import { Profile } from '@cemex-core/cmx-api/models/profiles-management/profile';
import { PumpTypes } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/pumpable-unload-type.loader.service';
import { _safe } from './safe-get.method';

export const profilesWhenTechnicalProductIsNotPumpable = (profiles: Profile[]): Profile[] => {
  return profiles.filter(profile => {
    return !PumpTypes.some(pumpType => pumpType.id === _safe(() => profile.project.projectProperties.unloadType.unloadTypeCode));
  });
};

export const profilesWhenTechnicalProductIsPumpable = (profiles: Profile[]): Profile[] => {
  return profiles.filter(profile => {
    return PumpTypes.some(pumpType => pumpType.id === _safe(() => profile.project.projectProperties.unloadType.unloadTypeCode));
  });
};
